<template>
  <div class="forgot-password-container">
    <div class="forgot-password-form-wrapper">
      <div class="forgot-password-header">
        <el-button @click="goBack" :icon="ArrowLeft" circle class="back-button" />
        <img src="../assets/images/logo.svg" alt="谐伴智能" class="logo">
        <h1>忘记密码</h1>
        <p>请输入您的注册邮箱以重置密码</p>
      </div>

      <el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="forgotPasswordFormRef" class="forgot-password-form">
        <el-form-item prop="email">
          <el-input v-model="forgotPasswordForm.email" placeholder="请输入注册邮箱" prefix-icon="Message" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="send-btn" @click="handleSendResetEmail" :loading="loading">
            发送重置链接
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="beian-info">
      <p><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2026026507号</a></p>
      <p>&copy; 谐伴智能版权所有 | <a href="https://xiebankeji.com" target="_blank">https://xiebankeji.com</a></p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { ArrowLeft, Message } from '@element-plus/icons-vue'

const router = useRouter()
const forgotPasswordFormRef = ref()
const loading = ref(false)

const forgotPasswordForm = reactive({
  email: ''
})

const forgotPasswordRules = {
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
  ]
}

const handleSendResetEmail = async () => {
  if (!forgotPasswordFormRef.value) return

  try {
    await forgotPasswordFormRef.value.validate()
    loading.value = true

    // 模拟发送重置邮件
    setTimeout(() => {
      ElMessage.success('重置密码链接已发送到您的邮箱，请查收！')
      loading.value = false
      router.push('/login')
    }, 1500)

  } catch (error) {
    console.error('发送重置邮件失败:', error)
    loading.value = false
  }
}

const goBack = () => {
  router.push('/login')
}
</script>

<style scoped>
.forgot-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.forgot-password-form-wrapper {
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 420px;
}

.forgot-password-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
}

.back-button {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
}

.forgot-password-header .logo {
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  border-radius: 50%;
  overflow: hidden;
}

.forgot-password-header h1 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.forgot-password-header p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.forgot-password-form {
  width: 100%;
}

.send-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
}

.beian-info {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  padding: 12px 0;
  font-size: 12px;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.beian-info a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-info a:hover {
  color: #4CAF50;
  text-decoration: underline;
}

@media (min-width: 768px) {
  .beian-info {
    font-size: 12px;
    padding: 12px 0;
    gap: 4px;
  }
}

@media (max-width: 480px) {
  .beian-info {
    font-size: 10px;
    padding: 10px 0;
    gap: 3px;
  }
}
</style>
